import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { FactoryEdit } from '@indutrust/factory-model';
import {
  factoryEditToLegacy,
  legacyToFactoryEdit,
} from '@indutrust/factory-util';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * Factory REST client against the legacy uae-back API.
 *
 * Writes use the Rails `{ factory: … }` envelope; reads normalize legacy
 * field names (`linkedin`, string `certification`, leaf ids under
 * `sub_technologies` / `sub_services` / `sub_products`) into
 * {@link FactoryEdit}.
 */
@Service()
export class FactoryApiClient extends BaseApiClient<FactoryEdit> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template = {};

  protected override fromWire(wire: unknown): FactoryEdit {
    return legacyToFactoryEdit(wire);
  }

  protected override toWire(entity: Partial<FactoryEdit>): unknown {
    return factoryEditToLegacy(entity);
  }

  get url(): string {
    return `${this.envService.getApiUrl()}/factories`;
  }
}
